<div class="wrap">
  <h2>Add a customer</h2>
  <form
    [formGroup]="addClientForm"
    #addClient
    (ngSubmit)="onSubmit()"
    *ngIf="!confirmAdd"
  >
    <mat-form-field appearance="outline">
      <mat-label>{{ "addClient.name.label" | translate }}</mat-label>
      <input matInput formControlName="name" />
      <!-- <mat-error>{{'addUser.username.erromMessage' | translate}}
            </mat-error> -->
    </mat-form-field>

    <div class="application_title">
      <h5>Application(s)</h5>
      <fa-icon [icon]="faPlus" (click)="addApplicationInput()"></fa-icon>
    </div>

    <div class="application_inputs" formArrayName="applicationList">
      <p class="no_app" *ngIf="!applicationControls?.controls?.length">
        No app
      </p>
      <ng-container *ngIf="applicationControls?.controls?.length">
        <div
          class="app_content_inputs"
          *ngFor="let item of applicationControls.controls; let i = index"
        >
          <div [formGroup]="item">
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "addClient.application.label" | translate }}</mat-label
              >
              <mat-select
                appearance="outline"
                formControlName="applicationName"
              >
                <ng-container *ngFor="let a of applications">
                  <mat-option
                    *ngIf="filterValuesApp(i, a?.ApplicationName)"
                    [value]="a"
                  >
                    {{ a?.ApplicationName }}</mat-option
                  >
                </ng-container>
              </mat-select>
            </mat-form-field>
            <fa-icon
              [icon]="faTrashAlt"
              (click)="deleteApplicationInput(i)"
            ></fa-icon>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="btn_action">
      <button class="canceled" type="button" (click)="dialog.closeAll()">
        Cancel
      </button>
      <button
        type="submit"
        [disabled]="addClientForm.invalid"
        [ngClass]="{
          isInactive: addClientForm.invalid,
          isActive: addClientForm.valid
        }"
      >
        Add
      </button>
    </div>
  </form>

  <div class="confirm" *ngIf="confirmAdd">
    <div class="validation_mail">
      <div class="check">
        <span class="icon-line line-tip"></span>
        <span class="icon-line line-long"></span>
        <div class="icon-circle"></div>
        <div class="icon-fix"></div>
      </div>
    </div>
    <h4>{{ "addClient.confirmAdd.label" | translate }}</h4>
  </div>
</div>
